import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-secondary-section-form',
  templateUrl: './secondary-section-form.component.html',
  styleUrls: ['./secondary-section-form.component.scss']
})


export class SecondarySectionFormComponent implements OnInit,OnChanges {
  addedSection: any;
  i: number;
  insideAddedSection: boolean = false;
  currentSelectedSection: number;
  sectionSuggestion: any;
  filteredNewSectionSuggestion: any =[];
  sectionQuery: any;
  subSectionQuery: string ='';
  insideAddedSubsection: boolean = false;
  currentSelection = 0;
  filteredNewSubsectionSuggestion: any =[];
  subsectionSuggestion: any = [];

  @ViewChild('sectionList', {static: false}) sectionList;
  @ViewChild('subSectionList', {static: false}) subSectionList;
  @ViewChildren('sectionInput') sectionField;
  @ViewChildren('subSectionInput') subSectionField;
  allSubSections: any;


  @Input()
  set index (input: number){
    this.i = input;
  }
  @Input()
  set sendAddedSection (addedSection: any) {
    this.addedSection = addedSection ? addedSection : [];
  }
  @Input()
  set sectionSuggestionList1 (sectionSuggestionList: any) {
    this.sectionSuggestion = sectionSuggestionList ? sectionSuggestionList : [];
  }
  @Input() subsectionSuggestionList:any;

  @Input()
  set listOfAllSubsections (subsectionList: any) {
    this.allSubSections = subsectionList ? subsectionList : [];
  }
  @Input() storyEditMode : boolean;

  @Output() sectionChanged: EventEmitter<number> = new EventEmitter();

  constructor() { }
  ngOnChanges(changes: SimpleChanges){
    this.subsectionSuggestion = this.subsectionSuggestionList;
  }

  ngOnInit() {
    if(this.addedSection['section']){
      this.sectionQuery = this.addedSection['section'];
    }
    if(this.addedSection['subSection']){
      this.subSectionQuery = this.addedSection['subSection'];
    }
  }

  focusInSuggest(model, index = 1) {
    if (model === 'section'){
        this.insideAddedSection = true;
        this.currentSelectedSection = index;
      if (this.addedSection['section'] === null || this.addedSection['section'] === '') {
        this.filteredNewSectionSuggestion = this.sectionSuggestion;
      }
    }
    if (model === 'subSection') {
      this.insideAddedSubsection = true;
      this.currentSelectedSection = index;
      if (this.subSectionQuery === '') {
        if ((this.addedSection['subSection'] !== null || this.addedSection['subSection'] ==='') && this.addedSection['section'] !== '') {
          this.filteredNewSubsectionSuggestion = this.subsectionSuggestion[this.addedSection['section']];
        } else {
          this.filteredNewSubsectionSuggestion = this.allSubSections;
        }
      }
    }
  }
  filterAutoCompleteUp(event, model) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      if (model === 'section') {
        // console.log('inside => ' + this.insideSection);
        if (this.insideAddedSection) {
          if (this.sectionQuery.length > 0) {
            this.filteredNewSectionSuggestion = this.sectionSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
            }.bind(this));
            // console.log('array => ' + this.filteredSectionSuggestion);
          } else {
            this.addedSection['section'] = '';
            this.addedSection['subSection'] = '';
            this.filteredNewSectionSuggestion = this.sectionSuggestion;
          }
        } else {
          this.insideAddedSection = true;
          this.filteredNewSectionSuggestion = [];
        }

      }
      else if (model === 'subSection') {
        if (this.insideAddedSubsection) {
          if (this.addedSection['section'] !== null && this.addedSection['section'].trim() !== '') {
            if (this.subSectionQuery.length > 0) {
              this.filteredNewSubsectionSuggestion = this.subsectionSuggestion[this.addedSection['section']].filter(function (el) {
                return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.addedSection['subSection'] = '';
              this.filteredNewSubsectionSuggestion = this.subsectionSuggestion[this.addedSection['section']];
            }
          } else {
            if (this.subSectionQuery.length > 0) {
              this.filteredNewSectionSuggestion = this.allSubSections.filter(function (el) {
                return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.addedSection['subSection'] = '';
              this.filteredNewSectionSuggestion = this.allSubSections;
            }
          }
        } else {
          this.insideAddedSubsection = true;
          this.filteredNewSubsectionSuggestion = [];
        }
      }

    }
    // this.currentSelection = 0;
    return true;
  }

  filterAutoCompleteDown(event, model) {
    if (event.key === 'Enter') {
      if (model === 'section') {
        this.insideAddedSection = false;
        this.selectAutoComplete(model, this.filteredNewSectionSuggestion[this.currentSelection]);
      }
      if (model === 'subSection') {
        this.insideAddedSubsection = false;
        this.selectAutoComplete(model, this.filteredNewSubsectionSuggestion[this.currentSelection]);
      }
    }
    else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'section') {
        if (this.currentSelection < (this.filteredNewSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.sectionList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'subSection') {
        if (this.currentSelection < (this.filteredNewSubsectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.subSectionList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideAddedSection = false;
      this.insideAddedSubsection = false;
      event.stopPropagation();
    }
    else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'section') {
          this.sectionList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'subSection') {
          this.subSectionList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 8) {
      if (model === 'section') {
        if(this.subsectionSuggestion[this.addedSection["section"]].indexOf(this.addedSection["subSection"])==-1)
        this.subsectionSuggestion[this.addedSection["section"]].push(this.addedSection["subSection"]);
        this.addedSection["section"]="";
      }
      if(model ==='subSection')
      {
        if(this.subsectionSuggestion[this.addedSection["section"]].indexOf(this.addedSection["subSection"])==-1)
        this.subsectionSuggestion[this.addedSection["section"]].push(this.addedSection["subSection"]);
        this.addedSection["subSection"]="";
      }
    }

    else {
      this.currentSelection = 0;
    }
    return true;
  }

  selectAutoComplete(model, item) {
    if (model === 'section') {
      this.sectionQuery = item;
      this.addedSection['section'] = item;
      if (
        !(this.subsectionSuggestion.hasOwnProperty(item))
        || (this.subsectionSuggestion[item].length < 1)
        || (this.subsectionSuggestion[item].indexOf(this.addedSection['subSection']) < 0)) {
        this.addedSection['subSection'] = '';
        this.subSectionQuery = '';
      }
      this.filteredNewSectionSuggestion = [];
      this.insideAddedSection = false;
    }
    else if (model === 'subSection') {
      this.subSectionQuery = item;
      this.addedSection['subSection'] = item;
      if (this.addedSection['section'] === null || this.addedSection['section'] === '') {
        for (const section in this.subsectionSuggestion) {
          if (section && this.subsectionSuggestion[section].indexOf(item) > -1) {
            this.addedSection['section'] = section;
            this.sectionQuery = section;
            break;
          }
        }
      }
      this.filteredNewSubsectionSuggestion = [];
    }
    this.sectionChanged.emit(this.addedSection)
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;

    if (this.sectionField['_results'][0] && clickedComponent === this.sectionField['_results'][0].nativeElement) {
      this.insideAddedSection = true;
      if (this.sectionQuery === '') {
        this.filteredNewSectionSuggestion = this.sectionSuggestion;
      }
      this.insideAddedSubsection = false;
      this.filteredNewSubsectionSuggestion = [];
    }
    else if (this.subSectionField['_results'][0] && clickedComponent === this.subSectionField['_results'][0].nativeElement) {
      this.insideAddedSubsection = true;
      if (this.subSectionQuery === '') {
        if (this.addedSection['section'] !== null && (this.addedSection['section']) !== '') {
          this.filteredNewSubsectionSuggestion = this.subsectionSuggestion[(this.addedSection['section'])];
        } else {
          this.filteredNewSubsectionSuggestion = this.allSubSections;
        }
      }
      this.insideAddedSection = false;
      this.filteredNewSectionSuggestion = [];
    }
    else {
      this.insideAddedSection = false;
      this.insideAddedSubsection = false;
      this.filteredNewSectionSuggestion = [];
      this.filteredNewSubsectionSuggestion = [];
    }
  }
}
